const BillingPaymentMethod = ({
    userBrand = '',
    userToken = '',
    accountNumber = '',
    accountName = '',
    accountAutopay = false,
    paymentMethodId = '',
    paymentType = '',
    accountType = '',
    abaCode = '',
    bankName = '',
    maskNumber = '',
    defaultPaymentMethod = '',
    brand = '',
    expirationMonth = '',
    expirationYear = '',
    description = '',
} = {}) => ({
    userBrand: String(userBrand),
    userToken: String(userToken),
    accountNumber: String(accountNumber),
    accountName: String(accountName),
    accountAutopay: Boolean(accountAutopay),
    paymentMethodId: String(paymentMethodId),
    paymentType: String(paymentType),
    accountType: String(accountType),
    abaCode: String(abaCode),
    bankName: String(bankName),
    maskNumber: String(maskNumber),
    defaultPaymentMethod: Boolean(defaultPaymentMethod),
    brand: String(brand),
    expirationMonth: Number(expirationMonth),
    expirationYear: Number(expirationYear),
    description: Number(description),
});

export default BillingPaymentMethod;
